import { render } from "./AlbinaView.vue?vue&type=template&id=14915fc6"
const script = {}

import "./AlbinaView.vue?vue&type=style&index=0&id=14915fc6&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__